import { shade } from 'polished'
import styled from 'styled-components'

import { ButtonLoaderStyled } from './ButtonLoaderStyled'
import { applyButtonColorCSS } from './utils'
import { CircleLoader } from '../../Loaders'
import { BaseButton } from '../BaseButton'

export const SecondaryButtonStyled = styled(BaseButton)`
  ${(props) =>
    applyButtonColorCSS(
      props.theme.colors.button.secondary.background,
      props.theme.colors.button.secondary.border,
      props.theme.colors.button.secondary.text,
      props.theme.colors.button.secondary.backgroundHover,
      props.theme.colors.button.secondary.borderHover
    )}

  &:hover {
    background-color: ${(props) => shade(0.05, props.theme.colors.white)};
  }

  &[disabled] {
    cursor: not-allowed;
    color: ${(props) => props.theme.colors.disabled};
    background-color: ${(props) =>
      props.theme.colors.button.secondary.background};
    border-color: ${(props) => props.theme.colors.disabled};
    box-shadow: none;

    &:hover,
    &:active {
      color: ${(props) => props.theme.colors.disabled};
      background-color: ${(props) =>
        props.theme.colors.button.secondary.background};
      border-color: ${(props) => props.theme.colors.disabled};
      box-shadow: none;
    }
  }

  ${ButtonLoaderStyled} {
    background-color: ${(props) => props.theme.colors.offwhite};

    ${CircleLoader} {
      border-color: ${(props) => props.theme.colors.disabled};
      border-bottom-color: transparent;
    }
  }
`
